<template>
  <div>
    <div class="handle_header">
        <el-card class="box-card">
          <div class="search">
            <el-form :inline="true">
              <el-form-item label="账号">
                <el-input size="mini" v-model="option.name" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="search">查询</el-button>
                <el-button size="mini" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
    <div class="tableList">
      <el-table :data="tableData" border style="width: 100%; margin-top: 10px"
        :row-style="{ 'font-size': '12px', color: '#324253' }"
        :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
        <el-table-column align="center" prop="name" label="账号"></el-table-column>
        <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
        <el-table-column align="center" prop="ip" label="IP"></el-table-column>
        <el-table-column align="center" prop="address" label="地址"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <a style="margin-left: 10px;" href="javascript:;" @click="deleteRow(scope, scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="tableData.length > 0"
        style="display: flex;justify-content: flex-end;"
        background
        @current-change="handleCurrentChange"
        :current-page="option.pageNum"
        :page-size="option.pageSize"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "userList",
  data() {
    return {
      total: 0,
      option: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
    };
  },
  methods: {
    getList() {
      this.tableData = [];
      this.$axios({
        url: '/list_report',
        method: 'get',
        params: this.option
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(val, currentPage) {
      this.option.pageNum = val;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.option.name = '';
      this.option.pageNum = 1;
      this.option.pageSize = 10;
      this.getList();
    },
    deleteRow(scope, id) {
      console.log('删除', id);
      var password = prompt('请输入安全码');
      if (!password) {
        return;
      }
      this.$axios({
        url: '/delete_report',
        method: 'post',
        data: {
          id: id,
          password: password,
        }
      }).then(res => {
        res = res.data;
        console.log('删除结果', res);
        if (!res || res.code != 200) {
          alert(res.msg || '删除失败');
          return;
        }
        this.tableData.splice(scope.$index, 1);
        alert('删除成功');
      }).catch(function(){
          alert('删除失败');
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.page {
  text-align: right;
}
</style>